import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Drip from 'drip';
import Analytics from '@/utils/Analytics';
import GoodsItem from './components/GoodsItem';
import throttle from '@/utils/throttle';
import { fetchGoodsList, fetchReGoodsList } from './request';
var titleTypeMap = {
  0: ['projectName', '周边商品'],
  1: ['shopName', '周边商品'],
  2: ['artistName', '同款周边商品']
};
export default {
  name: 'GoodsList',
  components: {
    GoodsItem: GoodsItem
  },
  props: {
    isPageList: {
      type: Boolean,
      default: true
    },
    payload: {
      // {venueId:xx, projectId: xx, celebrityId: xx}
      type: Object,
      default: null
    },
    // 场馆列表展示
    showHeader: {
      type: Boolean,
      default: true
    },
    // 是否是艺人主页
    isArtistPage: {
      type: Boolean,
      default: false
    },
    // 是否是列表接口
    isListApi: {
      type: Boolean,
      default: false
    },
    // 艺人名称
    artistName: {
      type: String,
      default: ''
    },
    // 项目名称
    projectName: {
      type: String,
      default: ''
    },
    // 场馆名称
    shopName: {
      type: String,
      default: ''
    },
    isCategory: {
      type: Boolean
    }
  },
  data: function data() {
    return {
      loading: false,
      hasMore: false,
      pageNo: 1,
      // 标题头
      title: '',
      relationType: 0,
      listOriginLenght: 0,
      goodsList: []
    };
  },
  watch: {
    payload: function payload(val, old) {
      if (val && old && JSON.stringify(val) === JSON.stringify(old)) {
        return;
      }
      this.pageNo = 1;
      this.getGoodsList();
    }
  },
  created: function created() {
    this.getGoodsList();
    if (this.isPageList) {
      this.bottoming = throttle(this.bottoming);
      window.addEventListener('scroll', this.bottoming, false);
    }
    if (!this.isListApi && this.isPageList) {
      // 设置标题头
      this.title = decodeURIComponent((this.$route.query || {}).title || '');
      Analytics('c_movie_80bsquo7');
      this.Env.setTitle('演出周边商品');
    }
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.bottoming, false);
  },
  methods: {
    bottoming: function bottoming() {
      if (this.hasMore) {
        this.pageNo = this.pageNo + 1;
        this.getGoodsList();
      }
    },
    // 获取场馆和场次的商品推荐列表
    getGoodsList: function getGoodsList() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var payload, _ref, queryBody, requestPromise, _yield$requestPromise, _yield$requestPromise2, data, relationType, code, msg, paging, _this$goodsList;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!Drip.UA.IS_GEWARA) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              payload = {};
              _ref = _this.$route.query || {}, queryBody = _ref.payload;
              if (_this.isListApi) {
                payload = {
                  pageNo: _this.pageNo,
                  pageSize: 20
                };
              }
              if (queryBody) {
                queryBody = JSON.parse(decodeURIComponent(queryBody));
                payload = Object.assign({}, queryBody);
              }
              if (_this.payload) {
                payload = Object.assign({}, payload, _this.payload);
              }
              if (!_this.loading) {
                _context.next = 9;
                break;
              }
              return _context.abrupt("return");
            case 9:
              _this.loading = true;
              requestPromise = _this.isListApi ? fetchGoodsList : fetchReGoodsList;
              _context.prev = 11;
              _context.next = 14;
              return requestPromise(payload);
            case 14:
              _yield$requestPromise = _context.sent;
              _yield$requestPromise2 = _yield$requestPromise.data;
              data = _yield$requestPromise2.derivationGoodsList;
              relationType = _yield$requestPromise2.relationType;
              code = _yield$requestPromise.code;
              msg = _yield$requestPromise.msg;
              paging = _yield$requestPromise.paging;
              if (!(code !== 200)) {
                _context.next = 23;
                break;
              }
              return _context.abrupt("return");
            case 23:
              _this.relationType = relationType;
              if (!(!_this.isPageList && data)) {
                _context.next = 28;
                break;
              }
              _this.listOriginLenght = data.length;
              _this.goodsList = data.slice(0, 3);
              return _context.abrupt("return");
            case 28:
              if (_this.pageNo === 1) {
                _this.goodsList = data;
              } else {
                (_this$goodsList = _this.goodsList).push.apply(_this$goodsList, _toConsumableArray(data || []));
              }
              if (paging) {
                _this.hasMore = paging.hasMore;
                _this.pageNo = paging.pageNo;
              }
              _context.next = 34;
              break;
            case 32:
              _context.prev = 32;
              _context.t0 = _context["catch"](11);
            case 34:
              _context.prev = 34;
              _this.loading = false;
              return _context.finish(34);
            case 37:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[11, 32, 34, 37]]);
      }))();
    },
    jump2More: function jump2More() {
      if (!this.payload) return;
      var type = titleTypeMap[this.relationType];
      var pageTitle = encodeURIComponent("".concat(this[type[0]]).concat(type[1]));
      this.go("/venue/goods-list?title=".concat(pageTitle, "&payload=").concat(encodeURIComponent(JSON.stringify(this.payload))));
      window.seedAction({
        bid: 'b_movie_2k03gtd6_mc',
        evt: 'click'
      });
    },
    goodsItemClass: function goodsItemClass(index) {
      var classList = [];
      if (this.isPageList) {
        return classList;
      }
      classList.push('order-list-item');
      var length = this.goodsList.length;
      if (length > 1) {
        classList.push('flex-column');
      }
      if (index === 0) {
        classList.push(length > 1 ? 'raduis-left only-one-item' : 'raduis');
      }
      if (index === 1 && length === 2) {
        classList.push('raduis-right');
      }
      if (index === 2) {
        classList.push('raduis-right');
      }
      return classList;
    }
  }
};